export default __webpack_public_path__ + "static/media/porfolio-template.80ad8824.png";